/**
 * App.tsx — composition root only.
 * Providers + a single NavigationContainer hosting the root navigator.
 * All routing lives under src/navigation/ (rootNavigator → authStack / appShell).
 */

import React from 'react';
import { NavigationContainer } from '@react-navigation/native';

import { ThemeProvider } from './src/context/themeContext';
import { AppProvider } from './src/context/appContext';
import { SessionProvider } from './src/context/sessionContext';
import ToastHost from './src/components/toastHost';
import GlobalErrorBoundary from './src/components/globalErrorBoundary';
import RootNavigator from './src/navigation/rootNavigator';
import { navigationRef } from './src/navigation/navigationRef';

export default function App() {
  return (
    // Outermost: catch any render/runtime crash anywhere in the tree and show
    // the fallback instead of a white screen.
    <GlobalErrorBoundary>
      <ThemeProvider>
        <AppProvider>
          <SessionProvider>
            <NavigationContainer ref={navigationRef}>
              <RootNavigator />
            </NavigationContainer>
            {/* Premium toast — modal-aware host portals above modals on web. */}
            <ToastHost />
          </SessionProvider>
        </AppProvider>
      </ThemeProvider>
    </GlobalErrorBoundary>
  );
}
